<template>
	<div class="editProfile">
		<div class="vx-row">
			<div class="vx-col w-full м mb-5">
				<vx-card>
					<h1>{{ !isCreatePage ? $t('managerEditing') : $t('managerCreating')}}</h1>
					<div class="row flex flex-col md:flex-row">
						<ProfileImage
							v-model="profile.photo"
							:hideDelete="true"
							@uploadPhoto="togglePhoto"
							class="mb-5 mr-0 sm:mr-8"
						/>
						<div class="vx-row mt-10 lg:mt-0">
							<div class="vx-col lg:w-2/3 xl:w-1/2">
								<div class="vx-row items-end">
									<div class="flex flex-col justify-end vx-col w-full sm:w-1/2 mb-2">
										<vs-input :label="$t('personName')" name="name" v-validate="'required|min:3'"
												  v-model="profile.first_name"/>
										<span
											:class="{ 'text-transparent': !errors.first('name') }"
											class="text-danger text-sm"
										>
											{{ $t('fieldFilledIncorrect') }}
										</span>
									</div>
									<div class="flex flex-col justify-end vx-col w-full sm:w-1/2 mb-2">
										<vs-input :label="$t('surname')" name="surname" v-validate="'required|min:3'"
												  v-model="profile.last_name"/>
										<span
											:class="{ 'text-transparent': !errors.first('surname') }"
											class="text-danger text-sm"
										>
											{{ $t('fieldFilledIncorrect') }}
										</span>
									</div>
									<div class="flex flex-col justify-end vx-col w-full sm:w-1/2 mb-2">
										<vs-input label="Email" name="email" v-validate="'required|email|min:3'"
												  v-model="profile.email"/>
										<span
											:class="{ 'text-transparent': !errors.first('email') }"
											class="text-danger text-sm"
										>
											{{ $t('fieldFilledIncorrect') }}
										</span>
									</div>

									<div class="flex flex-col justify-end vx-col w-full sm:w-1/2 mb-2">
										<vs-input :label="$t('emailAliasManager')" name="emailAlias"
												  v-validate="'required|min:3'"
												  v-model="profile.emailAlias"/>
										<span
											:class="{ 'text-transparent': !errors.first('emailAlias') }"
											class="text-danger text-sm"
										>
											{{ $t('fieldFilledIncorrect') }}
										</span>
									</div>

									<div class="flex flex-col justify-end vx-col w-full sm:w-1/2 mb-2">
										<vs-input :label="$t('emailForPayment')" name="emailRent"
												  v-validate="'required|email|min:3'"
												  v-model="profile.email_payment"/>
										<span
											:class="{ 'text-transparent': !errors.first('emailRent') }"
											class="text-danger text-sm"
										>
											{{ $t('fieldFilledIncorrect') }}
										</span>
									</div>
									<div class="vx-col w-full sm:w-1/2 mb-2">
										<vx-input-group>
											<div class="vs-component vs-con-input-label vs-input vs-input-primary">
												<label class="vs-input--label">{{ $t('birthDate') }}</label>
												<div class="vs-con-input">
												</div>
												<vs-datepicker
													v-model="profile.birth_date"
													format="dd.MM.yyyy"
													v-validate="'required'"
													name="date"
												></vs-datepicker>
											</div>
											<span
												:class="{ 'text-transparent': !errors.first('date') }"
												class="text-danger text-sm"
											>
												{{ $t('fieldFilledIncorrect') }}
											</span>
										</vx-input-group>
									</div>
									<div class="vx-col w-full sm:w-1/2 mb-2">
										<div class="vs-component vs-con-input-label vs-input vs-input-primary">
											<label class="vs-input--label">{{ $t('managerType') }}</label>
											<div class="vs-con-input">
											</div>
											<v-select v-model="profile.type" :reduce="country => country.id" label="name" v-validate="'required'"
													  name="type"
													  :options="typies" :dir="$vs.rtl ? 'rtl' : 'ltr'"
													  class="single-row-select"
											/>
										</div>
										<span
											:class="{ 'text-transparent': !errors.first('managerType') }"
											class="text-danger text-sm"
										>
											{{ $t('fieldFilledIncorrect') }}
										</span>
									</div>
									<div class="vx-col w-full sm:w-1/2 mb-2">
										<vs-phone
											:label="$t('phone')"
											name="phone"
											v-validate="'required|min:7|max:14'"
											v-model="profile.phone"
										/>
										<span
											:class="{ 'text-transparent': !errors.first('phone') }"
											class="text-danger text-sm"
										>
											{{ $t('fieldFilledIncorrect') }}
										</span>
									</div>
									<div class="vx-col w-full sm:w-1/2 mb-2">
										<div class="vs-component vs-con-input-label vs-input vs-input-primary">
											<label class="vs-input--label">{{ $t('country') }}</label>
											<div class="vs-con-input">
											</div>
											<v-select v-model="profile.country" :reduce="country => country.id" label="name" v-validate="'required'"
													  name="country"
													  :options="countries" :dir="$vs.rtl ? 'rtl' : 'ltr'"
													  class="single-row-select"
											/>
										</div>
										<span
											:class="{ 'text-transparent': !errors.first('country') }"
											class="text-danger text-sm"
										>
											{{ $t('fieldFilledIncorrect') }}
										</span>
									</div>
									<div class="flex flex-col justify-end vx-col w-full sm:w-1/2 mb-2">
										<div class="vs-component vs-con-input-label vs-input vs-input-primary">
											<label class="vs-input--label">{{ $t('sex') }}</label>
											<div class="vs-con-input">
											</div>
											<v-select v-model="profile.gender" :reduce="country => country.id" label="name" v-validate="'required'"
													  name="sex"
													  :options="genders" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
										</div>
										<span
											:class="{ 'text-transparent': !errors.first('sex') }"
											class="text-danger text-sm"
										>
											{{ $t('fieldFilledIncorrect') }}
										</span>
									</div>
									<div class="vx-col w-full mb-2">
										<div class="vs-component vs-con-input-label vs-input vs-input-primary">
											<label class="vs-input--label">{{ $t('language') }}</label>
											<div class="vs-con-input">
											</div>
											<v-select
												multiple
												:closeOnSelect="false"
												v-validate="'required'"
												name="lang"
												data
												v-model="profile.languages"
												:reduce="country => country.id"
												label="name"
												:options="languages"
												:dir="$vs.rtl ? 'rtl' : 'ltr'"
											/>
										</div>
										<span
											:class="{ 'text-transparent': !errors.first('lang') }"
											class="text-danger text-sm"
										>
											{{ $t('fieldFilledIncorrect') }}
										</span>
									</div>
								</div>
							</div>
							<div class="vx-col w-full lg:w-1/3 xl:w-1/4">
								<div class="vx-row">
									<div class="vx-col w-full sm:w-1/2 lg:w-full mb-2 w-full">
										<vx-input-group>
											<vs-password
												:label="$t('password')"
												data-vv-validate-on="blur"
												v-validate="passwordValidateProps"
												type="password"
												ref="oldpassword"
												name="password"
												v-model="oldpassword"
											/>
										</vx-input-group>
										<span
											:class="{ 'text-transparent': !errors.first('password') }"
											class="text-danger text-sm"
										>
											{{ $t('fieldFilledIncorrect') }}
										</span>
									</div>
									<div class="vx-col w-full sm:w-1/2 lg:w-full mb-2">
										<vx-input-group>
											<vs-password
												:label="$t('repeatPassword')"
												data-vv-validate-on="blur"
												v-validate="passwordValidateProps"
												type="password"
												ref="newpassword"
												name="newpassword"
												v-model="newpassword"
											/>
										</vx-input-group>
										<span
											:class="{ 'text-transparent': !errors.first('newpassword') }"
											class="text-danger text-sm"
										>
											{{ $t('fieldFilledIncorrect') }}
										</span>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="flex flex-end flex-wrap mb-3 my-5">
						<vs-button class="mr-5" @click="editAuthor">
							{{ $t('save') }}
						</vs-button>
						<vs-button color="warning" type="border" @click="$router.go(-1)">{{ $t('cancel') }}</vs-button>
					</div>
				</vx-card>
			</div>
		</div>
	</div>
</template>

<script>
import ProfileImage from "@/components/ProfileImage";
import vSelect from 'vue-select'
import datepicker from 'vuejs-datepicker'
import moment from 'moment'
import notifier from "../../mixins/notifier";

export default {
	name: "EditAuthor",
	mixins: [notifier],
	components: {
		ProfileImage,
		datepicker,
		'v-select': vSelect,
	},
	computed: {
		minDate() {
			return new Date();
		},
		isCreatePage() {
			return this.$route.path === '/manager/create';
		},
		passwordValidateProps() {
			let output = "min:6|max:32";
			return this.isCreatePage
				? 'required|' + output
				: output;
		}
	},
	methods: {
		async togglePhoto(err,file){
			try {
				this.profile.photo = (await this.$http.post('/upload/one',
					this.$formData({file: file[0]}))).data.data.url;

			}catch (e) {
				this.notifyError(e.message);
			}
		},
		async editAuthor(){
			try {
				if(!await this.$validator.validateAll()) return;

				let formData = Object.assign({}, this.profile);

				if(this.newpassword !== '' && this.newpassword !== null) {
					formData.password = this.newpassword;
				}
				if(this.oldpassword !== '' && this.oldpassword !== null) {
					formData.password2 = this.oldpassword;
				}

				formData.birth_date = moment(formData.birth_date).format("YYYY-MM-DD HH:MM:ss")
				let route = this.$route.path !== '/manager/create'
					? '/admin/manager/update/' + this.$route.params.id
					: '/admin/manager/create';

				let res = await this.$http.post(route,formData);
				this.notifySuccess(this.$t('dataIsSaved'));
				this.$router.back();

			}catch (e) {
				if(e.errors){
					Object.values(e.errors).forEach(err=>{
						this.notifyError(err);
					});
				}else{
					this.notifyError(e.message);
				}
			}
		},
		toggleShow(ref) {
			let input = this.$refs[ref].$el.querySelector('input');
			input.type = input.type === 'password' ? 'text' : 'password';
		},
		createEmptyProfile() {
			return {
				photo: '',
				description: '',
				name: '',
				email: '',
				emailRent: '',
				surname: '',
				date: '',
				phone: '',
				sex: '',
				country: '',
				type: '',
				about: '',
				oldpassword: '',
				newpassword: '',
				lang: [],
				subject: [],
			};
		}
	},
	async created () {
		if(!this.isCreatePage){
			this.profile = (await this.$http.get('/admin/manager/view/'+this.$route.params.id)).data.data;
		} else {
			this.profile = this.createEmptyProfile();
		}

		this.languages = (await this.$http.get('/settings/get-languages')).data.data;
		this.subjects =  (await this.$http.get('/settings/get-subjects')).data.data;
		this.countries = (await this.$http.get('/settings/get-countries')).data.data
		this.typies = (await this.$http.get('/settings/get-manager-types')).data.data
		this.genders =	 (await this.$http.get('/settings/get-genders')).data.data

		if(this.profile.gender === 0) {
			this.profile.gender = 1
			this.$nextTick(() => this.profile.gender = 0)
		}
	},
	data() {
		return {
			popupActive: false,
			val: '',
			description: '',
			name: '',
			email: '',
			emailRent: '',
			surname: '',
			date: '',
			phone: '',
			sex: '',
			country: '',
			type: '',
			about: '',
			oldpassword: '',
			newpassword: '',
			lang: [],
			subject: [],

			languages: [],
			subjects: [],
			countries: [],
			genders: [],
			profile: {},
		}
	}
}
</script>

<style lang="scss">
@import "../../assets/scss/vuexy/variables";
@import "../../assets/scss/vuexy/functions";

.vs-textarea {
	height: 110px;
}


.editProfile {
	.vx-input-group .append-text.btn-addon .vs-button {
		height: 2.65rem;
		width: 2.65rem;
		justify-content: center;
		padding: 0 !important;
		margin-top: 20px;
		align-items: center;

		&-text {
			margin-top: 4px;
		}
	}

	.vs-con-input-label {
		width: 100%;
	}

	h1 {
		font-size: 18px;
		color: #626262;
		margin-bottom: 15px;
		font-weight: 700;
	}


	table {
		margin-bottom: 20px;
		padding-left: 15px;

		tr {

			td {
				padding-bottom: 7px;

				&:first-child {
					width: 250px;
					font-weight: 600;
				}
			}

		}
	}

	.photo {
		width: 170px;
		height: 170px;
		border-radius: 10px;
		overflow: hidden;
		margin: 15px 0 ;
		margin-right: 35px;
		flex-shrink: 0;
		.con-input-upload,.img-upload{
			width: 100%;
			margin: 0;
			height: 100%;
		}
		.con-img-upload{
			height: 100%;
		}
		.con-upload{
			height: 100%;
		}
		img {
			max-width: 100%;
			margin: 0 auto;
			height: 100%;
			width: 100%;
		}
	}

	.info {
		width: 170px;
		flex-shrink: 0;
		align-items: center;
		justify-content: center;
		margin-right: 30px;
	}

	.box {
		display: flex;
		font-size: 25px;
		align-items: center;
		margin-bottom: 22px;
	}

	.bottom {
		display: flex;
		justify-content: flex-end;
	}
}

.vs-popup {
	max-width: 400px !important;

	.vs-textarea {
		height: 100px;
	}

	&--title {
		h3 {
			color: $warning;
		}
	}

	p {
		padding: 1rem;
	}

	&--button {
		display: flex;
		justify-content: flex-end;
		border-top: 1px solid #e4e4e4;
		padding: 1rem;
		padding-bottom: 0.5rem;
	}
}

</style>
